import React from 'react';
import { Provider } from 'react-redux';
import configureStore from '../../redux/store/configureStore';
import './Layout.scss';
import SecurityRouter from './SecurityRouter/SecurityRouter';

const Layout = ({
  left,
  right,
  header,
  isPremium,
  getVirtualAccountStatus,
}) => {
  const store = configureStore({});
  return (
    <Provider store={store}>
      <div className='layout' id='layout'>
        <div className='layout__header'>{header}</div>
        <div
          className={`layout__navbar ${isPremium ? ' navbar--premium' : ''}`}
        >
          {left}
        </div>
        <SecurityRouter getVirtualAccountStatus={getVirtualAccountStatus}>
          <main className='layout__content'>{right}</main>
        </SecurityRouter>
      </div>
    </Provider>
  );
};

export default Layout;
